var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0996 20.5002L1.39961 0.700195L0.0996094 2.0002L1.59961 3.5002C1.19961 3.9002 0.999609 4.4002 0.999609 5.0002V17.0002C0.999609 18.1002 1.89961 19.0002 2.99961 19.0002H17.0996L19.7996 21.7002L21.0996 20.5002ZM2.99961 7.0002V5.0002L3.29961 5.2002L8.59961 10.5002L2.99961 7.0002ZM12.3996 9.2002L6.19961 3.0002H18.9996C20.0996 3.0002 20.9996 3.9002 20.9996 5.0002V17.0002C20.9996 17.2002 20.9996 17.5002 20.8996 17.7002L13.5996 10.4002L18.9996 7.0002V5.0002L12.3996 9.2002Z",
    fill: "#ECC94B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOff);
export default __webpack_public_path__ + "static/media/email-off.f3c621633e39a7ac464d24d8b900e1ac.svg";
export { ForwardRef as ReactComponent };